import React, { createContext, useContext } from "react";

/**
 * Context exposing the element id that the surrounding configForm is
 * editing. The DocumentEditorView right pane wraps the configForm render
 * in this provider so configForm fields (e.g. ElementLogicRules) can
 * find out which canvas element they're configuring.
 *
 * Moved from apps/web/src/components/views/DocumentEditorView/
 * ConfigFormSubjectContext.tsx so the shared `useElementValue` hook in
 * DocumentContext can branch on configForm context without pulling
 * editor-only paths back into apps/forms or apps/mobile.
 *
 * Non-editor hosts (forms-app, mobile) never wrap their tree in this
 * provider, so `useConfigFormSubject` returns `null` and the answer
 * envelope is applied.
 */
const ConfigFormSubjectContext = createContext<string | null>(null);

interface ProviderProps {
  subjectElementId: string;
  children: React.ReactNode;
}

export const ConfigFormSubjectProvider: React.FC<ProviderProps> = ({
  subjectElementId,
  children,
}) => (
  <ConfigFormSubjectContext.Provider value={subjectElementId}>
    {children}
  </ConfigFormSubjectContext.Provider>
);

/** Returns the subject element id, or null when not inside a provider. */
export const useConfigFormSubject = (): string | null =>
  useContext(ConfigFormSubjectContext);
